export default __webpack_public_path__ + "static/step8-34af431db2e19c55ded3a0a9b3299d86.svg";